export default {"src":"/_next/static/media/down-arrow.4ad44398.svg","height":6,"width":12,"blurWidth":0,"blurHeight":0};